import settings from "./settings";
import global from "./global";
export default {
  settings,
  global,
};
